import debounce from 'lodash.debounce'

export default () => {
  const toggle = document.querySelector('.js-toggle-page-header')
  const { body } = document
  const treshHold = window.innerHeight * 0.2

  toggle.addEventListener('click', () => {
    if (body.classList.contains('nav-active')) {
      // Close nav
      body.classList.remove('nav-active')
      if (window.scrollY > treshHold) {
        // Re-add scroll state
        body.classList.add('page-header-scroll')
      }
    } else {
      body.classList.remove('page-header-scroll') // Always remove scroll state
      body.classList.add('nav-active')
    }
  })

  window.addEventListener(
    'scroll',
    debounce(() => {
      if (window.scrollY > treshHold) {
        if (!body.classList.contains('nav-active')) {
          body.classList.add('page-header-scroll')
        }
      } else {
        body.classList.remove('page-header-scroll')
      }
    }),
    20
  )
}



// WEBPACK FOOTER //
// ./src/js/modules/PageHeader.js